<template>
  <div class="transit-item grid-item" :style="{ color, borderColor: color }">
    <div class="time">
      <strong>{{ minutes }}</strong> min
    </div>
    
    <div class="destination">
      To {{ destinationLabel }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TransitItem',
    props: {
      time: { type: Number, default: 0, required: true }, // seconds
      destinationLabel: { type: String, default: '', required: true }
    },
    computed: {
      minutes () {
        return Math.ceil(this.time / 60)
      },
      color () {
        return '#' + (this.$route.params.color || 'FFFFFF')
      }
    }
  }
</script>

<style>
  .panels-grid .transit-item {
    padding-top: 40px;
    text-transform: uppercase;
  }

  .transit-item .time {
    font-size: 36px;
    font-weight: bold;
    margin-left: 10px;
  }

  .transit-item .time strong {
    font-size: 110px;
  }

  .transit-item .destination {
    font-size: 26px;
  }

.transit-item .direction {
  font-size: 20px;
  font-weight: normal;
}

</style>